/** Legal text is deliberately German-only regardless of UI language (legal requirement, not a
 *  translation gap) - see LegalPage.tsx / LegalLinks.tsx. */
export const IMPRESSUM_TEXT = `Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz, vormals § 5 TMG)


Diensteanbieter

Lukas Lukowski
Zum Butterberg 31
21629 Neu Wulmstorf
Deutschland

Roofora ist eine unabhängige Plattform für den Vergleich von
Photovoltaik-Angeboten und die Vermittlung passender Fachbetriebe.
Die Nutzung der Plattform ist derzeit für alle Beteiligten
kostenfrei.


Kontakt

E-Mail: info@roofora.de

Für Anfragen steht zusätzlich das Kontaktformular auf der Website
zur Verfügung.


Umsatzsteuer-Identifikationsnummer

Da kein Gewerbe angemeldet ist, wird derzeit keine
Umsatzsteuer-Identifikationsnummer nach § 27a UStG geführt.


Verantwortlich für den Inhalt

Lukas Lukowski
Zum Butterberg 31
21629 Neu Wulmstorf


Streitschlichtung

Die Europäische Kommission stellt eine Plattform zur
Online-Streitbeilegung (OS) bereit:
https://ec.europa.eu/consumers/odr/

Wir sind nicht verpflichtet und nicht bereit, an einem
Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
teilzunehmen.


Haftung für Inhalte

Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene
Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter
jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
Informationen zu überwachen oder nach Umständen zu forschen, die
auf eine rechtswidrige Tätigkeit hinweisen.

Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
Informationen nach den allgemeinen Gesetzen bleiben hiervon
unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
diese Inhalte umgehend entfernen.

Anmerkung zur Plattform: Über diese Website vermittelte Angebote
und Inhalte (z. B. von Handwerksbetrieben eingestellte Angebote,
Bewertungen, hochgeladene Bilder) stammen von den jeweiligen
Nutzerinnen und Nutzern. Für die Richtigkeit dieser fremden
Inhalte wird keine Gewähr übernommen.


Haftung für Links

Unser Angebot enthält gegebenenfalls Links zu externen Websites
Dritter (z. B. zu genutzten externen Diensten), auf deren Inhalte
wir keinen Einfluss haben. Deshalb können wir für diese fremden
Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
der Seiten verantwortlich. Die verlinkten Seiten wurden zum
Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht
erkennbar.

Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
derartige Links umgehend entfernen.


Urheberrecht

Die durch die Betreiber dieser Website erstellten Inhalte und
Werke unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung
des jeweiligen Autors bzw. Erstellers.

Soweit Inhalte auf dieser Seite nicht vom Betreiber erstellt
wurden (z. B. von Nutzerinnen und Nutzern hochgeladene Fotos,
eingestellte Angebote), werden die Urheberrechte Dritter beachtet.
Insbesondere werden Inhalte Dritter als solche gekennzeichnet.
Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam
werden, bitten wir um einen entsprechenden Hinweis. Bei
Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte
umgehend entfernen.


Marken- und Herstellerlogos

Alle Marken- und Herstellernamen sowie die dargestellten Logos sind
Eigentum ihrer jeweiligen Inhaber und dienen ausschließlich der
Identifikation der angebotenen Produkte und Hersteller. Eine
Partnerschaft, Zertifizierung oder Empfehlung durch die jeweiligen
Markeninhaber besteht nur, wenn dies ausdrücklich angegeben ist.`